import { createSelector } from '@ngrx/store';

import { AI_UMC } from '../constant';
import { INote, IState } from '../model';

export const selectAiUMCState = (state: any) => state[AI_UMC];

const aiUMCReleaseNotes = createSelector(
  selectAiUMCState,
  (state): IState => state
);

export const getAiUMCReleaseNotes = createSelector(
  aiUMCReleaseNotes,
  ({ notes }): INote[] => notes
);

export const getSelectedUMCReleaseNote = createSelector(
  aiUMCReleaseNotes,
  ({ note }): INote => note
);

export const getUMCReleaseNoteCreating = createSelector(
  aiUMCReleaseNotes,
  ({ isCreating }): boolean => isCreating
);

export const getUMCReleaseNotesLoading = createSelector(
  aiUMCReleaseNotes,
  ({ processing }): boolean => processing
);

export const getTriggerSaveApiInDoc = createSelector(
  aiUMCReleaseNotes,
  ({
    triggerSaveApiInDoc,
    payloadForUMCPostDocSave,
  }): {
    triggerSaveApiInDoc: boolean;
    payloadForUMCPostDocSave?: { nodeId: string; sectionId: string } | null;
  } => ({ triggerSaveApiInDoc, payloadForUMCPostDocSave })
);

export const getCurrentSelectedAIUMCNotes = createSelector(
  aiUMCReleaseNotes,
  ({ currentSelectedAIUMCNotes }): INote[] => currentSelectedAIUMCNotes
);
